import type { ProjectStatus } from "./types";

type PagePathSegment = {
  label: string;
  href?: string;
};

export function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

export function getProjectStatusLabel(status: ProjectStatus): string {
  switch (status) {
    case "draft":
      return "草稿";
    case "in_progress":
      return "进行中";
    case "ready":
      return "已完成";
    default:
      return "草稿";
  }
}

export function renderPagePath(segments: PagePathSegment[]): string {
  const path = segments
    .map((segment) => {
      const label = escapeHtml(segment.label);
      if (!segment.href) {
        return `<span class="page-path-current">${label}</span>`;
      }

      return `<a class="page-path-link" href="${escapeHtml(segment.href)}">${label}</a>`;
    })
    .join('<span class="page-path-separator">&nbsp;&rarr;&nbsp;</span>');

  return `
    <div class="page-path" aria-label="当前页面路径">
      ${path}
    </div>
  `;
}
